<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg5 sm5>
                <v-card pa-0>
                  <v-toolbar card color="white">
                    <v-text-field
                    flat
                    solo
                    prepend-icon="search"
                    placeholder="Type something"
                    v-model="available.search"
                    hide-details
                    class="hidden-sm-and-down"
                    
                    ></v-text-field>                                                    
                  </v-toolbar>
                  <v-divider></v-divider>
                  <v-card-text class="pa-0">
                    <v-data-table
                      :headers="available.headers"
                      :search="available.search"
                      :items="available.items"
                      :loading="loading"
                      :pagination.sync="pagination"
                      :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                      class="elevation-1"
                      item-key="name"
                      select-all                
                      v-model="available.selected"
                      >
                      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
                      <template slot="items" slot-scope="props">
                      <td style="width:5%">
                        <v-checkbox
                          primary
                          hide-details
                          v-model="props.selected"
                        ></v-checkbox>
                      </td>                                
                        <td>{{ props.item.name }}</td>                  
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
            </v-flex>  
            <v-flex lg2 sm2>
                <v-btn block :loading="loading" color="success" @click="assign()" dark>Assign >></v-btn>
                <v-btn block :loading="loading" color="warning" @click="remove()" dark><< Cancel</v-btn>
            </v-flex>
            <v-flex lg5 sm5>
                <v-card pa-0>
                  <v-toolbar card color="white">
                    <v-text-field
                    flat
                    solo
                    prepend-icon="search"
                    placeholder="Type something"
                    v-model="assigned.search"
                    hide-details
                    class="hidden-sm-and-down"
                    ></v-text-field>                                                  
                  </v-toolbar>
                  <v-divider></v-divider>
                  <v-card-text class="pa-0">
                    <v-data-table
                      :headers="assigned.headers"
                      :search="assigned.search"
                      :items="assigned.items"
                      :loading="loading"
                      :pagination.sync="pagination"
                      :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                      class="elevation-1"
                      item-key="name"
                      select-all                
                      v-model="assigned.selected"
                      >
                      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
                      <template slot="items" slot-scope="props">
                      <td style="width:5%">
                        <v-checkbox
                          primary
                          hide-details
                          v-model="props.selected"
                        ></v-checkbox>
                      </td>                                
                        <td>{{ props.item.name }}</td>                  
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
            </v-flex>  
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Route  from '@/apps/main/models/rbac/Route';    
import moment from 'moment';

var model = new Route();

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
        formPath : '/accounting/coa-type/form',
        
        loading  : true,
        pagination: {},
        available  : {
            search : '',
            selected: [],
            headers: [              
              { text: 'Name', value: 'name', align:'left'},                            
            ],
            items: []
        },
        assigned : {
            search  : '',
            selected: [],
            headers: [              
              { text: 'Name', value: 'name'},                            
            ],
            items: []
        },
    }),  
    mounted(){ this.init() },        
    created () {
        if( model.vuex ){
            var context = this;        
            context.$store.watch(
                function (state) { return state },
                function () { model.all().then(data => { context.available.items = data }) },{ deep: true }
            );                                     
        }
    },
    methods: {      
        format(tgl) { return moment(tgl).format('DD-MM-YYYY')},
        
        init(){
            if(this.$route.query.flag){ 
                Object.assign(this.pagination, {sortBy : 'flag', descending:true});
            }
            model.all().then(data => {      
                //console.log(data);
                this.available.items = [];
                this.assigned.items = [];
                data.available.forEach((item)=>{
                    this.available.items.push({name:item});
                })  
                data.assigned.forEach((item)=>{
                    this.assigned.items.push({name:item});
                })  
                this.loading = false;
            });                                         
        },
                
        assign(){
            var arr = [];
            this.available.selected.forEach((item)=>{
                arr.push(item.name);
            });
            this.loading = true;
            model.assign({routes:arr}).then(data =>{                
                this.init();
            });
        },
                
        remove(){
            var arr = [];
            this.assigned.selected.forEach((item)=>{
                arr.push(item.name);
            });
            this.loading = true;
            model.remove({routes:arr}).then(data =>{                
                this.init();
            });
        },
                        
        resolve(props){
            let info = props.item.info;
            if( info.action == 'synch' ){                
                this.$router.push({path:'/accounting/acc-periode/form', query: {id: props.item.id}}); 
            } else if(info.action == 'fetch') {                
                window.getApp.$emit('APP_OPEN_FETCH', props);
            }            
        }
    }
}
</script>